import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { OptionType } from '@evinced-private/ui-common';

import { getMfaOwnerOptions } from 'src/apps/mfa/services/MfaDashboardService';
import { MFA_OWNER_OPTIONS } from 'src/common/providers/reactQueryProvider/QueryKeys';

export const useMfaOwnerOptionsQuery = (): UseQueryResult<OptionType[]> => {
	const sessionDetailsQuery = useQuery([MFA_OWNER_OPTIONS], () => getMfaOwnerOptions());

	return sessionDetailsQuery;
};
